enum FetchAction {
  DELETE = 'DELETE',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  CLONE = 'CLONE',
  COPY = 'COPY',
}

export default FetchAction;
